import { render, staticRenderFns } from "./ConvertDetail.vue?vue&type=template&id=b8d13bd2&scoped=true&"
import script from "./ConvertDetail.vue?vue&type=script&lang=js&"
export * from "./ConvertDetail.vue?vue&type=script&lang=js&"
import style0 from "./ConvertDetail.vue?vue&type=style&index=0&id=b8d13bd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d13bd2",
  null
  
)

export default component.exports